import { RenewVisaHistoryUploadApplicationPage } from "@/features/renew-visa/pages/RenewVisaHistoryUploadApplication";

const RenewVisaHistoryUploadApplication = () => {
  return <RenewVisaHistoryUploadApplicationPage />;
};

export default RenewVisaHistoryUploadApplication;
